import React, { Component } from 'react';
import { func, string, bool, oneOfType, node } from 'prop-types';
import classnames from 'classnames/bind';

import Modal from '@components/Modal/Modal';
import styles from './ModalPreviewer.css';

const cx = classnames.bind(styles);
const getImagePath = imagePath => require(`@assets/images/${imagePath}`);

class ModalPreviewer extends Component {

  static propTypes = {
    children: oneOfType([func, node]).isRequired,
    previewText: string.isRequired,
    imagePath: string,
    className: string,
    modalCustomClass: string,
    withGrid: bool,
    modalOpened: bool,
  };

  static defaultProps = {
    modalOpened: false
  }

  state = {
    modalOpened: this.props.modalOpened,
    withGrid: true,
  }

  handleOverlayClick = e => {
    e.preventDefault();

    this.setState({
      modalOpened: true
    });
  }

  onCloseModal = () => {
    this.setState({
      modalOpened: false
    });
  }

  render() {
    const { children, previewText, imagePath, className, modalCustomClass, withGrid } = this.props;
    const { modalOpened } = this.state;

    const modalPreviewerClasses = classnames(
      className,
      styles.modalPreviewerContainer,
      'flex'
    );

    const modalClasses = cx('fullScreenModal', { 'modalWithGrid': withGrid });

    return (
      <div className={modalPreviewerClasses}>
        { imagePath &&
          <div
            className={classnames(styles.previewImage, 'image-preview')}
            style={{backgroundImage: `url(${getImagePath(imagePath)})`}}
          >
          </div>
        }

        <div
          className={classnames(styles.overlay, 'flex flex-align-center flex-justify-center')}
          onClick={this.handleOverlayClick}
        >
          <span className="section-title">{previewText}</span>
        </div>

        <Modal
          open={modalOpened}
          onClose={this.onCloseModal}
          customClasses={classnames('preview-modal', modalClasses, modalCustomClass)}
        >
          {typeof(children) === 'function' ? children() : children}
        </Modal>
      </div>
    );
  }
}

export default ModalPreviewer;



// WEBPACK FOOTER //
// ./src/components/ModalPreviewer/ModalPreviewer.js